export default __webpack_public_path__ + "static/media/blue.f269627d.gif";